import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import Radio from '@atlaskit/radio/radio';
import { token } from '@atlaskit/tokens';

const i18n = defineMessages({
	actionSelectionHeader: {
		id: 'bulk-permissions.space.action-selection-header',
		defaultMessage: 'Action to perform<asterisk>*</asterisk>',
		description: 'Header text of the action selection section',
	},
	actionSelectionAdd: {
		id: 'bulk-permissions.space.action-selection-add',
		defaultMessage: 'Add or change access',
		description: 'Option to add or change access to all selected spaces',
	},
	actionSelectionRemove: {
		id: 'bulk-permissions.space.action-selection-remove',
		defaultMessage: 'Remove access',
		description: 'Option to remove access from all selected spaces',
	},
});

export enum ActionSelection {
	AddOrChangeAccess = 'add-or-change-access',
	RemoveAccess = 'remove-access',
}

const actionSelectionHeaderStyle = xcss({
	font: token('font.body.large'),
	fontWeight: token('font.weight.medium'),
	display: 'flex',
	flexDirection: 'row',
	paddingTop: 'space.300',
	paddingBottom: 'space.100',
});

const asteriskStyle = xcss({
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
	color: 'color.text.accent.red',
});

type ActionSelectionRadioButtonProps = {
	actionSelection: ActionSelection;
	onRadioChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	isDisabled?: boolean;
};

export const ActionSelectionRadioButtons = ({
	actionSelection,
	onRadioChange,
	isDisabled = false,
}: ActionSelectionRadioButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Box xcss={actionSelectionHeaderStyle} testId="action-selection-radio-buttons">
				{formatMessage(i18n.actionSelectionHeader, {
					asterisk: (chunks: React.ReactNode[]) => <Box xcss={asteriskStyle}>{chunks}</Box>,
				})}
			</Box>
			<Box>
				<Radio
					value={ActionSelection.AddOrChangeAccess}
					onChange={onRadioChange}
					isChecked={actionSelection === ActionSelection.AddOrChangeAccess}
					isDisabled={isDisabled}
					name="action-selection"
					label={formatMessage(i18n.actionSelectionAdd)}
				/>
				<Radio
					value={ActionSelection.RemoveAccess}
					onChange={onRadioChange}
					isChecked={actionSelection === ActionSelection.RemoveAccess}
					isDisabled={isDisabled}
					name="action-selection"
					label={formatMessage(i18n.actionSelectionRemove)}
				/>
			</Box>
		</>
	);
};
